import React, { useState } from 'react';
import { authAPI } from '../services/api';
import './Login.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const data = await authAPI.forgotPassword(email.trim());
      if (data.success) {
        setSuccess('Password reset instructions have been sent to your email.');
        setEmail('');
      } else {
        setError(data.message || 'Failed to send reset email');
      }
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">🐯</div>
        <h2>Reset Password</h2>
        <p className="login-subtitle">Enter your email to receive reset instructions.</p>

        {success && <div className="success-message">✅ {success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email" value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              placeholder="Enter your email" disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span> {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="login-button">
            {loading ? <><span className="spinner"></span> Sending...</> : 'Send Reset Link'}
          </button>
        </form>

        <div className="login-footer">
          <p className="footer-links">
            <a href="/login">Back to Login</a>
          </p>
        </div>
      </div>
    </div>
  );
}